import { Component } from '@angular/core';

import { AppLauncherStateService } from '../app-launcher-state.service';

@Component({
	selector: 'sd-feedback-widget',
	templateUrl: './feedback-widget.component.html',
})
export class FeedbackWidgetComponent {
	public feedbackType = 'Confusing step';
	public feedbackText = '';
	public feedbackEmail = '';

	constructor(public readonly state: AppLauncherStateService) {}

	public open(): void {
		this.feedbackType = 'Confusing step';
		this.feedbackText = '';
		this.feedbackEmail = this.state.accountEmail;
		this.state.openFeedback();
	}

	public close(): void {
		this.state.closeFeedback();
	}

	public submit(): void {
		this.state.submitFeedback(
			this.feedbackType,
			this.feedbackText,
			this.feedbackEmail,
		);
	}
}
